/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".wrapper[_ngcontent-%COMP%]{display:flex;flex-direction:column;justify-content:center;align-items:center}.top-info-title[_ngcontent-%COMP%]{font-size:32px;line-height:120%;font-weight:400;margin-bottom:16px}.top-info-text[_ngcontent-%COMP%]{font-weight:400;font-size:14px;line-height:20px;margin-bottom:24px}.non-trial-status[_ngcontent-%COMP%]{width:100%;background:#e0fff5;color:#1a3349;border:1px solid #21d196;border-radius:8px;font-size:14px;text-align:center;opacity:.9;padding:16px 0;margin-bottom:32px;line-height:150%}"];
export { styles as styles };
